/* Wholesale display builder — scoped to its own Shopify page section. */
(() => {
  'use strict';
  document.querySelectorAll('[data-wholesale-builder]').forEach(init);

  function init(root) {
    const one = (selector) => root.querySelector(selector);
    const all = (selector) => [...root.querySelectorAll(selector)];
    const catalogNode = one('[data-wdb-catalog]');
    let catalog = [];
    try { catalog = JSON.parse(catalogNode.textContent).filter(p => p.id && p.image && p.title); }
    catch (error) { console.error('Wholesale product collection could not be loaded', error); }

    // 24 physical hooks, twelve on each side. Duplicate designs are permitted.
    let slots = Array(24).fill(null);
    let activeSide = 0;
    let activeHook = 0;
    let previousFocus = null;
    let cartQuantities = new Map();
    const storageKey = 'discgolfpins-wholesale-display-v2';
    let restoredSelection = false;
    const money = (cents) => (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    const displayId = Number(root.dataset.displayVariant || 0);
    const displayValid = displayId > 0 && Number(root.dataset.displayPrice) === 0 && root.dataset.displayAvailable === 'true';

    function stockLimit(product) {
      if (!product.available) return 0;
      return !product.tracked || product.continue ? Infinity : Math.max(0, Number(product.stock) || 0);
    }
    function selectedQuantity(id, excludingHook = -1) {
      return slots.reduce((sum, slot, index) => sum + (index !== excludingHook && slot && slot.id === String(id) ? slot.qty : 0), 0);
    }
    function remaining(product, excludingHook = -1) {
      return stockLimit(product) - (cartQuantities.get(String(product.id)) || 0) - selectedQuantity(product.id, excludingHook);
    }
    async function readCart() {
      const route = window.Shopify?.routes?.root || '/';
      const response = await fetch(route + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('We could not check your cart. Please refresh and try again.');
      const cart = await response.json();
      cartQuantities = new Map();
      (cart.items || []).forEach(item => {
        const id = String(item.variant_id || item.id);
        cartQuantities.set(id, (cartQuantities.get(id) || 0) + Number(item.quantity || 0));
      });
      return cart;
    }

    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (Array.isArray(saved) && saved.length === 24) {
        restoredSelection = true;
        slots = saved.map(item => item && catalog.some(p => String(p.id) === String(item.id))
          ? { id: String(item.id), qty: Math.max(4, Math.min(6, Number(item.qty) || 4)) } : null);
      }
    } catch (_) { /* Storage might be unavailable. Ordering still works. */ }

    function lines() {
      const grouped = new Map();
      let pins = 0, hooks = 0, retail = 0;
      slots.forEach(slot => {
        if (!slot) return;
        const product = catalog.find(p => String(p.id) === slot.id);
        if (!product) return;
        hooks++; pins += slot.qty; retail += product.price * slot.qty;
        const line = grouped.get(slot.id) || { product, quantity: 0, hooks: 0 };
        line.quantity += slot.qty; line.hooks++;
        grouped.set(slot.id, line);
      });
      return { items: [...grouped.values()], pins, hooks, retail };
    }

    function node(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }

    function render() {
      const grid = one('[data-wdb-rack]');
      grid.replaceChildren();
      for (let index = activeSide * 12; index < activeSide * 12 + 12; index++) {
        const selection = slots[index];
        const product = selection && catalog.find(p => String(p.id) === selection.id);
        const button = node('button', 'wdb__hook' + (!product ? ' wdb__hook--empty' : ''));
        button.type = 'button';
        button.setAttribute('aria-label', 'Choose a pin for hook ' + (index + 1));
        if (product) {
          const image = node('img');
          image.src = product.image; image.alt = product.title; image.loading = 'lazy';
          button.append(image, node('span', 'wdb__hook-label', product.title), node('span', 'wdb__hook-count', '×' + selection.qty));
        } else {
          button.append(node('span', 'wdb__hook-label', 'Hook ' + (index + 1)), node('span', null, '+'));
        }
        button.addEventListener('click', () => openPicker(index));
        grid.append(button);
      }
      all('[data-wdb-side]').forEach(button => button.setAttribute('aria-selected', String(Number(button.dataset.wdbSide) === activeSide)));
      const tally = lines();
      one('[data-wdb-filled]').textContent = tally.hooks;
      one('[data-wdb-progress]').style.width = ((tally.hooks / 24) * 100) + '%';
      one('[data-wdb-count]').textContent = tally.pins;
      one('[data-wdb-unique]').textContent = tally.items.length;
      if (one('[data-wdb-retail]')) one('[data-wdb-retail]').textContent = money(tally.retail);
      if (one('[data-wdb-wholesale]')) one('[data-wdb-wholesale]').textContent = money(tally.retail * .5);
      one('[data-wdb-review]').disabled = tally.items.length === 0;
      try { sessionStorage.setItem(storageKey, JSON.stringify(slots)); } catch (_) {}
    }

    function notify(message) { one('[data-wdb-status]').textContent = message; }
    function setSide(side) { activeSide = side; render(); }
    function open(panel) {
      previousFocus = document.activeElement;
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      const focusable = panel.querySelector('input, button');
      if (focusable) focusable.focus();
    }
    function close() {
      all('.wdb__panel').forEach(panel => { panel.hidden = true; });
      document.body.style.overflow = '';
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    }
    all('[data-wdb-close]').forEach(button => button.addEventListener('click', close));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && all('.wdb__panel').some(panel => !panel.hidden)) close();
    });

    async function openPicker(index) {
      activeHook = index;
      one('[data-wdb-hook-label]').textContent = 'SIDE ' + (index < 12 ? 'A' : 'B') + ' · HOOK ' + (index + 1);
      one('[data-wdb-search]').value = '';
      one('[data-wdb-qty]').value = String(slots[index]?.qty || 4);
      renderProducts();
      open(one('[data-wdb-picker]'));
      try { await readCart(); renderProducts(); }
      catch (_) { notify('Cart availability could not be refreshed. Final inventory will be checked before checkout.'); }
    }
    function renderProducts() {
      const search = one('[data-wdb-search]').value.toLowerCase().trim();
      const matches = catalog.filter(product => product.title.toLowerCase().includes(search));
      const quantity = Number(one('[data-wdb-qty]').value);
      const selectable = matches.filter(product => remaining(product, activeHook) >= quantity);
      one('[data-wdb-matches]').textContent = selectable.length + ' selectable of ' + matches.length + ' designs';
      const container = one('[data-wdb-products]');
      container.replaceChildren();
      if (!matches.length) container.append(node('p', null, catalog.length ? 'No matching pins.' : 'Choose a wholesale-eligible pin collection in the theme editor.'));
      matches.forEach(product => {
        const button = node('button'); button.type = 'button';
        const image = node('img'); image.src = product.image; image.alt = ''; image.loading = 'lazy';
        button.append(image, node('b', null, product.title));
        button.setAttribute('aria-label', 'Choose ' + product.title);
        const available = remaining(product, activeHook);
        if (available < quantity) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.style.opacity = '0.5';
          button.style.cursor = 'not-allowed';
          button.append(node('small', 'wdb__stock-warning',
            available <= 0 ? 'OUT OF STOCK FOR THIS DISPLAY' :
              'Only ' + available + ' available. Choose another design or a lower quantity.'));
        }
        button.addEventListener('click', async () => {
          try { await readCart(); }
          catch (error) { notify(error.message); return; }
          const qty = Number(one('[data-wdb-qty]').value);
          if (remaining(product, activeHook) < qty) {
            renderProducts(); notify('Not enough stock remains for ' + product.title + '.'); return;
          }
          slots[activeHook] = { id: String(product.id), qty };
          close(); render(); notify('Hook ' + (activeHook + 1) + ' updated.');
        });
        container.append(button);
      });
    }
    one('[data-wdb-search]').addEventListener('input', renderProducts);
    one('[data-wdb-qty]').addEventListener('change', renderProducts);
    one('[data-wdb-remove]').addEventListener('click', () => {
      slots[activeHook] = null; close(); render(); notify('Hook cleared.');
    });
    all('[data-wdb-side]').forEach(button => button.addEventListener('click', () => setSide(Number(button.dataset.wdbSide))));
    one('[data-wdb-flip]').addEventListener('click', () => setSide(activeSide === 0 ? 1 : 0));

    one('[data-wdb-bestsellers]').addEventListener('click', async () => {
      if (!catalog.length) return notify('First select a wholesale pin collection in your theme editor.');
      try { await readCart(); }
      catch (error) { return notify(error.message); }
      // Collection order determines the recommended assortment. Merchants can use Shopify's Best selling sort.
      slots = Array(24).fill(null);
      let hook = 0;
      for (const product of catalog) {
        if (hook >= 24) break;
        if (remaining(product) < 4) continue;
        slots[hook++] = { id: String(product.id), qty: 4 };
      }
      activeSide = 0; render(); notify(hook === 24
        ? 'Suggested assortment added. Select any hook to swap a design.'
        : 'Only ' + hook + ' hooks could be filled with in-stock products. Please choose replacements.');
    });
    one('[data-wdb-clear]').addEventListener('click', () => {
      if (slots.some(Boolean) && !window.confirm('Clear the entire display and start again?')) return;
      slots = Array(24).fill(null); activeSide = 0; render(); notify('Display cleared.');
    });

    function reviewOrder() {
      const tally = lines();
      one('[data-wdb-cart-message]').textContent = tally.hooks + ' of 24 hooks · ' + tally.pins + ' pins · ' + tally.items.length + ' different designs';
      const container = one('[data-wdb-cart-lines]'); container.replaceChildren();
      tally.items.forEach(line => {
        const row = node('div', 'wdb__cart-line');
        const image = node('img'); image.src = line.product.image; image.alt = '';
        const desc = node('div'); desc.append(node('strong', null, line.product.title), node('small', null, line.quantity + ' pins across ' + line.hooks + ' hook(s)'));
        row.append(image, desc, node('strong', null, line.quantity + ' ×'));
        container.append(row);
      });
      const displayRow = node('div', 'wdb__cart-line');
      displayRow.append(node('span', null, '🎁'), node('strong', null, 'FREE Spinning Retail Display'), node('strong', null, '1 ×'));
      container.append(displayRow);
      one('[data-wdb-add]').disabled = tally.hooks !== 24 || !displayValid;
      one('[data-wdb-add]').textContent = tally.hooks === 24 ? 'Add Display Assortment to Cart →' : 'Fill all 24 hooks to continue';
      one('[data-wdb-error]').hidden = displayValid;
      if (!displayValid) one('[data-wdb-error]').textContent = 'The FREE Retail Display must be published to the Online Store, available, and priced at $0.00 before starter orders can be submitted.';
      open(one('[data-wdb-cart]'));
    }
    one('[data-wdb-review]').addEventListener('click', reviewOrder);

    one('[data-wdb-add]').addEventListener('click', async () => {
      const tally = lines();
      if (tally.hooks !== 24 || tally.pins < 96 || !displayValid) return;
      const button = one('[data-wdb-add]'); button.disabled = true; button.textContent = 'Adding your pins…';
      one('[data-wdb-error]').hidden = true;
      const route = window.Shopify?.routes?.root || '/';
      try {
        const before = await readCart();
        const unavailable = tally.items.filter(line =>
          stockLimit(line.product) < (cartQuantities.get(String(line.product.id)) || 0) + line.quantity);
        if (unavailable.length) {
          throw new Error('Not enough available inventory for: ' + unavailable.map(line => line.product.title).join(', ') + '. Please replace these designs or review quantities already in your cart.');
        }
        const displayAlreadyInCart = (cartQuantities.get(String(displayId)) || 0) > 0;
        const requested = tally.items.map(line => ({ id: Number(line.product.id), quantity: line.quantity, properties: { '_Display': '24-Hook Wholesale Starter' } }));
        if (!displayAlreadyInCart) requested.push({ id: displayId, quantity: 1, properties: { '_Display': 'Complimentary Starter Display' } });
        const response = await fetch(route + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: requested })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          // Shopify can partially add items even when the request reports an error.
          const after = await readCart().catch(() => null);
          const added = after ? (after.items || []).reduce((sum, item) => {
            const id = String(item.variant_id || item.id);
            const was = (before.items || []).filter(old => String(old.variant_id || old.id) === id)
              .reduce((count, old) => count + Number(old.quantity || 0), 0);
            return sum + Math.max(0, Number(item.quantity || 0) - was);
          }, 0) : 0;
          throw new Error((error.description || error.message || 'Could not add the complete assortment.') +
            (added ? ' Shopify added ' + added + ' item(s) before reporting this error. Review your cart before trying again.' :
              ' No complete order was confirmed. Please review your cart before trying again.'));
        }
        const after = await readCart();
        const short = requested.filter(line => {
          const id = String(line.id);
          const oldQty = (before.items || []).filter(item => String(item.variant_id || item.id) === id)
            .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
          return (cartQuantities.get(id) || 0) - oldQty < line.quantity;
        });
        if (short.length) throw new Error('Shopify did not confirm all requested quantities, including the free display if applicable. Please review your cart before trying again.');
        window.location.assign(route + 'cart');
      } catch (error) {
        one('[data-wdb-error]').textContent = error.message || 'Unable to add the assortment. Please try again.';
        one('[data-wdb-error]').hidden = false;
        button.disabled = false; button.textContent = 'Try Adding to Cart Again →';
      }
    });

    if (!catalog.length) {
      one('[data-wdb-bestsellers]').disabled = true;
      notify('Setup needed: select the wholesale pin collection in the theme editor.');
    }
    render();
    // Start new visitors with the first 24 in-stock bestsellers. Preserve any
    // deliberate edits (including Start Empty) when the page is revisited.
    if (!restoredSelection && catalog.length) one('[data-wdb-bestsellers]').click();
  }
})();